<template>
    <div
            class="window-chat"
            :class="{
                'window-chat_mobile': $vuetify.breakpoint.xsOnly
            }"
    >
        <div
                v-if="!isOpen && !$vuetify.breakpoint.xsOnly"
                class="window-chat__btn elevation-6"
                :class="{
                    'window-chat__btn_new-message': countUnread,
                }"
                @click="isOpen = true"
        >
            <v-icon>mdi-chat</v-icon>
            <div
                    v-if="countUnread"
                    class="window-chat__count"
            >
                <div class="window-chat__count-wrap">{{ countUnread }}</div>
            </div>
        </div>
        <div v-if="isOpen" class="window-chat__window">
            <div class="window-chat__head">
                <div class="window-chat__label">{{ $t('msg.curator') }}</div>
                <div class="window-chat__close" @click="isOpen = false">
                    <v-icon light>mdi-close</v-icon>
                </div>
            </div>
            <div class="window-chat__content">
                <chat
                        :messages="messages"
                        ref="chat"
                        @scroll-top="$emit('scroll-top')"
                        @send="$emit('send', $event)"
                        :my-types="myTypes"
                ></chat>
            </div>
        </div>
    </div>
</template>

<script>
    import Chat from "./Chat";

    export default {
        components: {Chat},
        props: {
            messages: {type: Array, default: () => []},
            myTypes: {type: Array, default: () => []},
            countUnread: {type: Number, default: null}
        },
        data() {
            return {
                isOpen: false
            }
        },
        watch: {
            isOpen(v) {
                if (v) {
                    this.$emit('open');

                    if (this.$vuetify.breakpoint.lgAndUp) {
                        setTimeout(() => {
                          if (this.$refs.chat !== undefined) {
                            this.$refs.chat.$refs.input.focus();
                          }
                        }, 500);
                    }

                } else {
                    this.$emit('close');
                }
            }
        },
        methods: {
            openChat() {
              this.isOpen = !this.isOpen;
            },
            scrollToBottom() {
                this.$refs.chat.scrollToBottom();
            },
            scrollToMessage(id) {
                this.$refs.chat.scrollToMessage(id);
            }
        }
    }
</script>

<style lang="scss">
    @import "src/assets/scss/vars";

    $right: 20px;

    @keyframes rotation {
        0% {
            transform:rotate(0deg);
        }
        100% {
            transform:rotate(360deg);
        }
    }

    @keyframes new-message {
      0% {
        font-size: 35px;
        color: #fff;
      }
      4% {
        font-size: 80px;
        color: $colorSecondary;
      }
      8% {
        font-size: 35px;
        color: #fff;
      }
      100% {
        font-size: 35px;
        color: #fff;
      }
    }

    .window-chat {
        z-index: 150;

        &.window-chat_mobile {
            .window-chat__window {
                width: calc(100% - 10px);
                height: calc(100% - 10px);
                max-height: inherit;
                right: 5px;
                bottom: 5px;
            }
        }
        .window-chat__btn {
            width: 70px;
            height: 70px;
            position: fixed;
            bottom: 20px;
            right: $right;
            background-color: $colorPrimary;
            border-radius: 50%;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;

            &:hover {
                opacity: 0.75;
            }
            &.window-chat__btn_new-message {
                .v-icon {
                    animation-name: new-message;
                    animation-duration: 3s;
                    animation-iteration-count: infinite;
                    animation-timing-function: linear;
                }
            }
            .v-icon {
                color: #fff;
                font-size: 35px;
            }
        }
        .window-chat__window {
            width: 350px;
            height: 500px;
            max-height: calc(100% - 40px);
            position: fixed;
            bottom: 20px;
            right: $right;
            border-radius: 5px;
            box-shadow: 0 0 20px 7px rgba(90, 90, 90, 0.61);
            overflow: hidden;
        }
        .window-chat__head {
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: $colorSecondary;
            color: #333;
        }
        .window-chat__label {
            padding: 15px 20px;
            font-size: 20px;
            font-weight: 300;
        }
        .window-chat__close {
            width: 30px;
            height: 30px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;

            &:hover {
                opacity: 0.7;
            }
        }
        .window-chat__content {
            height: calc(100% - 60px - 56px);
            background-color: #fff;
        }
        .window-chat__count {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .window-chat__count-wrap {
            font-size: 14px;
            font-weight: 300;
        }
    }
</style>